import { implementCustomExpressions } from '../__generated/implementation.js';
export const topWithWidthExpressions = implementCustomExpressions({
    TopWithSide: {
        $width: (s)=>s.side,
        $length: (s)=>s.side,
        $sizeDescription: (s)=>`${Math.round(s.side)}"`,
        $price: (s)=>{
            const p = s.$table.$pricingConfig;
            const pricing = p.tops[s.type] ?? {
                basePrice: 0,
                compoundingRate: 0.05,
                pricingStep: 6
            };
            const sideSteps = Math.trunc((Math.round(s.side) - s.$topDataMap[s.type].sizing.side.default) / pricing.pricingStep);
            return Math.round(pricing.basePrice * Math.pow(1 + pricing.compoundingRate, sideSteps));
        },
        $minWidth: (s)=>s.$topDataMap[s.type].sizing.side.min,
        $maxWidth: (s)=>s.$topDataMap[s.type].sizing.side.max,
        $defaultWidth: (s)=>s.$topDataMap[s.type].sizing.side.default,
        $defaultLength: (s)=>s.$topDataMap[s.type].sizing.side.default,
        $distance: (s)=>{
            return s.$leafCenterVisible ? s.$leafLength * s.leafAmount : 0;
        },
        $distanceScaleZero: ()=>{
            // scaleZero = 0 means no separation (shape key at 0)
            return 0;
        },
        $distanceScaleOne: (s)=>{
            // scaleOne = scaleDelta means full separation range
            return s.$topDataMap[s.type].sizing.distance.scaleDelta;
        },
        $leafBevel: (s)=>{
            // When leaf is enabled, set to scaleOne to show bevel edge in the middle
            return s.$leafCenterVisible ? 0.05 : 0;
        },
        $leafBevelScaleZero: ()=>0,
        $leafBevelScaleOne: ()=>0.05
    }
});

//# sourceMappingURL=top-with-side.js.map